import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faMessageSmile, faUser, faEnvelope, faPhone, faGlobe, faHexagonCheck, faArrowLeft, faAngleLeft, faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { Form, InputGroup } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { Divider } from 'primereact/divider';
import './profile.scss';
import { useDispatch, useSelector } from 'react-redux';
import { login, performLogout } from '../../stores/auth';
import MaskedInput from 'react-text-mask';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { ProfileServiceApi } from "../../services/profile/api";
import { Configuration } from "../../services/profile/configuration";
import { Toast } from 'primereact/toast';
import moment from 'moment/moment';
import DatePicker from '../../components/pickers/datePicker';
import Search from '../../components/search/search';
import { APIControl } from '../../helpers/APIControl';
import { DashboardApi, MainApi } from '../../services/authentication/api';
import { Configuration as authenticationConfiguration } from '../../services/authentication/configuration';

import { useTranslation } from "react-i18next";
import { setMainDefaultSecurity } from '../../stores/security';
import { setProfileBasicDetail } from '../../stores/profileSlice';
import trFlag from '../../assets/img/tr.svg';
import usFlag from '../../assets/img/us.svg';
import { countryItems, cityItems } from '../Authentication/register/helpers/locationData';
import { Image } from 'primereact/image';
import { InputTextarea } from 'primereact/inputtextarea';
import ChangePasswordTab from './components/ChangePasswordTab';

const Profile = () => {
  const { t, i18n } = useTranslation();
  const profileService = new ProfileServiceApi(new Configuration({ basePath: process.env.REACT_APP_PROFILE_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_PROFILE_API_BASE_PATH));
  const dashboardApi = new DashboardApi(new authenticationConfiguration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH));
  const mainApi = new MainApi(new authenticationConfiguration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH));
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [date, setDate] = useState(null);
  const [basicDetail, setBasicDetail] = useState();
  const [activeListItemId, setListActiveIndex] = useState();

  const [userName, setUserName] = useState("");
  const [userSurname, setUserSurname] = useState("");
  const [userDisplayName, setUserDisplayName] = useState("");
  const [userDisplaySurname, setUserDisplaySurname] = useState("");
  const [userMobilPhone, setUserMobilPhone] = useState("");
  const [userBirthDate, setUserBirthDate] = useState("");
  const [userOfficePhone, setUserOfficePhone] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userDisplayEmail, setUserDisplayEmail] = useState("");
  const [userCountry, setUserCountry] = useState({ id: "90", name: "Türkiye", flag: null });
  const [gender, setGender] = useState("");
  const [languageCode, setLanguageCode] = useState("");
  const [profileTypes, setProfileTypes] = useState([]);
  const [userProfileId, setUserProfileId] = useState();

  const [defaultSecurity, setDefaultSecurity] = useState("");
  const [defaultSecuritySetItem, setDefaultSecuritySetItem] = useState();
  const [selectedCity, setSelectedCity] = useState("");
  const [address, setAddress] = useState("");
  const [loadingBasicUpdate, setLoadingBasicUpdate] = useState(false);
  const [loadingPasswordUpdate, setLoadingPasswordUpdate] = useState(false);
  const [loadingDefaultsUpdate, setLoadingDefaultsUpdate] = useState(false);

  // Original values to track changes
  const [originalValues, setOriginalValues] = useState({
    name: '',
    surname: '',
    birthdate: '',
    officephone: '',
    mobilePhone: '',
    email: '',
    country: '',
    gender: '',
    languageCode: '',
    address: '',
    selectedInvestment: '',
    selectedProducts: [],
    selectedCity: '',
    defaultSecurity: '',
  });

  const profliListItems = [
    { id: 'basicDetails', name: 'profile.basicDetails.menuTitle', isActive: true },
    { id: 'defaultSettings', name: 'profile.defaults.menuTitle', isActive: false },
    { id: 'changePassrword', name: 'profile.changePassword.menuTitle', isActive: false },
    { id: 'changeLanguage', name: 'profile.language.menuTitle', isActive: false },
  ];



  const interestedProducts = [
    { id: 1, name: t('profile.basicDetails.stock'), selected: false, code: "Stock" },
    { id: 2, name: t('profile.basicDetails.stockAndDerivative'), selected: false, code: "StockAndDerivative" },
    { id: 3, name: t('profile.basicDetails.exchangeAndDerivative'), selected: false, code: "ExchangeAndDerivative" },
  ];
  const investmentAmount = [
    { id: 4, name: t('profile.basicDetails.notSpecify'), selected: false, code: "NotSpecify" },
    { id: 1, name: t('profile.basicDetails.underMillion'), selected: false, code: "UnderMillion" },
    { id: 2, name: t('profile.basicDetails.millionBetween'), selected: false, code: "MillionBetween" },
    { id: 3, name: t('profile.basicDetails.over10Million'), selected: false, code: "Over10Million" },
  ];
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedInvestment, setSelectedInvestment] = useState(investmentAmount[0]);

  useEffect(() => {
    getProfileBasicDetail();

    setListActiveIndex('basicDetails');
    setProfileTypes(profliListItems);
    getDefaultSecurity();
  }, []);

  const handleListItemClick = (index, item) => {
    setListActiveIndex(item.id);

    profliListItems.forEach((element) => { element.isActive = false; if (element.id === item.id) element.isActive = true; });
    setProfileTypes([...profliListItems]);
  };

  //#region LOGOUT

  const handleLogout = async () => {
    await dispatch(performLogout());
    window.location.href = '/auth/login';
  };

  //#endregion LOGOUT

  const changeGender = (item) => {
    setGender(item);
  };

  const changeLanguage = (item) => {
    setLanguageCode(item);
  };

  const changeCountryValue = (item) => {
    setUserCountry(item);
  };

  const changeProductValue = (item) => {
    setSelectedProducts(item);
  };

  const toggleProductSelection = (item) => {
    const isSelected = selectedProducts.some(product => product.id === item.id);
    if (isSelected) {
      setSelectedProducts(selectedProducts.filter(product => product.id !== item.id));
    } else {
      setSelectedProducts([...selectedProducts, item]);
    }
  };

  const changeInvestmentValue = (item) => {
    setSelectedInvestment(item);
  };

  const handleCityChange = (item) => {
    setSelectedCity(item);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const extractUsername = (email) => {
    const parts = email.split('@');
    if (parts.length > 0) {
      return parts[0];
    }
    return '';
  };

  const user = useSelector((state) => state.auth?.user);
  const token = useSelector((state) => state.auth?.token);
  const userMail = useSelector((state) => state.auth?.email);

  addLocale('tr', {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ['pazartesi', 'salı', 'çarşamba', 'perşembe', 'cuma', 'cumartesi', 'pazar'],
    dayNamesShort: ['pzt', 'sal', 'çar', 'per', 'cum', 'cmt', 'paz'],
    dayNamesMin: ['P', 'S', 'Ç', 'P', 'C', 'C', 'P'],
    monthNames: ['ocak', 'şubat', 'mart', 'nisan', 'mayıs', 'haziran', 'temmuz', 'ağustos', 'eylül', 'ekim', 'kasım', 'aralık'],
    monthNamesShort: ['ock', 'şbt', 'mrt', 'nsn', 'mays', 'hzr', 'tmz', 'ağs', 'eyl', 'ekm', 'ksm', 'arl'],
    today: 'Bugün',
    clear: 'Temizle',
  });

  const selectedBirtdate = (date) => {
    let formattedDate = moment(date).format('YYYY-MM-DD');
    setUserBirthDate(formattedDate);
  }



  const selectedSearchItem = (e) => {
    console.log("selectedSearchItem: ", e)
    setDefaultSecurity(e.document.code);
    setDefaultSecuritySetItem(e.document);
  }

  const getProfileBasicDetail = async () => {
    try {
      await profileService.profileBasicprofiledetailGet(token).then((response) => {
        console.log('getProfileBasicDetail', response);
        const responseError = response.data?.error;
        // E-Şube (müşteri no) girişinde profil kaydı henüz oluşmamış olabilir.
        // Bu durumu hata olarak göstermeyip boş, düzenlenebilir bir form sun.
        if (responseError && responseError.length > 0) {
          console.log('getProfileBasicDetail', responseError);
          return;
        }
        const profile = response.data?.profile || {};

        // Store original values for change detection
        setOriginalValues({
          name: profile.name || "",
          surname: profile.surname || "",
          birthdate: formatbirthdate(profile.birthday),
          officephone: profile.officephone || "",
          mobilePhone: profile.mobilePhone || "",
          email: profile.email || "",
          country: profile.country || "",
          gender: profile.gender || "",
          languageCode: profile.languagecode || "",
          address: profile.address || "",
          selectedInvestment: profile.amount || "",
          selectedProducts: profile.interestedProducts || [],
          selectedCity: profile.cityCode || "",
          defaultSecurity: '',
        });

        setBasicDetail(profile);
        setUserName(profile.name || "");
        setUserSurname(profile.surname || "");
        setUserDisplayName(profile.name || "");
        setUserDisplaySurname(profile.surname || "");
        setUserBirthDate(formatbirthdate(profile.birthday));
        setUserProfileId(profile.id);
        setUserOfficePhone(profile.officephone || "");
        setUserMobilPhone(profile.mobilePhone || "");
        setUserEmail(profile.email || "");
        setUserDisplayEmail(profile.email || "");
        setUserCountry(getCountryItem(profile.country));
        setGender(profile.gender || "");
        setLanguageCode(profile.languagecode || "");

        dispatch(setProfileBasicDetail(profile));

        // Kontrol ve varsayılan değerler
        const foundInvestment = investmentAmount.find(item => item.code === profile.amount);
        setSelectedInvestment(foundInvestment || investmentAmount[0]);

        // Handle interested products - coming directly as an array from API
        if (profile.interestedProducts && Array.isArray(profile.interestedProducts)) {
          // Map API values to UI component objects
          const foundProducts = interestedProducts.filter(item =>
            profile.interestedProducts.includes(item.code)
          );
          setSelectedProducts(foundProducts.length > 0 ? foundProducts : []);
        }

        const foundCity = cityItems.find(item => item.code === profile.cityCode);
        setSelectedCity(foundCity || cityItems[0]);

        setAddress(profile.address || "");
      }).catch((error) => {
        console.log('getProfileBasicDetail', error);
      });
    } catch (error) {
      console.log('getProfile', error);
    }
  };

  const getCountryItem = (code) => {
    const foundCountry = countryItems.find(item => String(item.code) === String(code));
    return foundCountry || countryItems[0];
  };

  const formatbirthdate = (dateString) => {

    if (!dateString) {
      return '';
    }

    if (dateString.indexOf("-") > -1) {
      return dateString;
    }
    // Tarihi parçalara ayır
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    // yyyy-mm-dd formatına getir
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;

  }


  // Get default security with original value tracking
  const getDefaultSecurity = () => {
    try {
      profileService.profileFetchstockGet(token).then((response) => {
        if (response.data.error.length > 0) {
          toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data.error, life: 3000 });
          return;
        }
        setDefaultSecurity(response.data.securityCode);
        setOriginalValues(prev => ({ ...prev, defaultSecurity: response.data.securityCode }));
        dispatch(setMainDefaultSecurity(response.data.securityCode));
      }).catch((error) => {
        console.log('getDefaultSecurity', error);
      });
    } catch (error) {
      console.log('getDefaultSecurity', error);
    }
  }

  // Check if basic profile has changes with debugging
  const hasProfileChanges = () => {
    const interestedProducts = selectedProducts.map(product => product.code);
    // Debug object to see what's different
    const differences = {
      name: userName !== originalValues.name,
      surname: userSurname !== originalValues.surname,
      birthdate: userBirthDate !== originalValues.birthdate,
      officephone: userOfficePhone !== originalValues.officephone,
      mobilePhone: userMobilPhone !== originalValues.mobilePhone,
      email: userEmail !== originalValues.email,
      country: String(userCountry.code) !== String(originalValues.country), // Ensure both are strings
      gender: gender !== originalValues.gender,
      languageCode: languageCode !== originalValues.languageCode,
      address: address !== originalValues.address,
      selectedInvestment: selectedInvestment.code !== originalValues.selectedInvestment,
      selectedProducts: JSON.stringify(interestedProducts) !== JSON.stringify(originalValues.selectedProducts),
      selectedCity: (selectedCity && selectedCity.code) !== originalValues.selectedCity
    };

    // Log the differences to help debug
    console.log("Profile change detection:", differences);
    console.log("Original values:", originalValues);
    console.log("Current values:", {
      name: userName,
      surname: userSurname,
      birthdate: userBirthDate,
      officephone: userOfficePhone,
      mobilePhone: userMobilPhone,
      email: userEmail,
      country: userCountry.code,
      gender: gender,
      languageCode: languageCode,
      address: address,
      selectedInvestment: selectedInvestment.code,
      selectedProducts: interestedProducts,
      selectedCity: selectedCity ? selectedCity.code : null
    });

    // Check if any field has changed
    return Object.values(differences).some(changed => changed === true);
  };



  // Check if default security has changed
  const hasSecurityChanges = () => {
    return defaultSecuritySetItem &&
      defaultSecuritySetItem.code !== originalValues.defaultSecurity;
  };

  const updateProfileBasicDetail = () => {
    if (activeListItemId !== 'basicDetails' && activeListItemId !== 'changeLanguage') {
      return;
    }

    // Check if there are changes
    if (!hasProfileChanges()) {
      toast.current.show({
        severity: 'warn',
        summary: t("warning"),
        detail: t("noChangesWarning"),
        life: 3000
      });
      return;
    }

    setLoadingBasicUpdate(true);

    // Extract product codes from selectedProducts as an array of strings
    // This will create: ["Stock"] or ["Stock", "StockAndDerivative"]
    const interestedProducts = selectedProducts.map(product => product.code);

    profileService.profileBasicUpdateGet(
      token,
      userName,
      userSurname,
      userBirthDate,
      userOfficePhone,
      userMobilPhone,
      userEmail,
      userCountry.code,
      gender,
      languageCode,
      address,
      selectedInvestment.code,
      interestedProducts, // Pass as array of strings: ["Stock", "StockAndDerivative"]
      selectedCity.code
    ).then((response) => {
      if (response.data.error.length > 0) {
        toast.current.show({ severity: 'error', summary: t("error"), detail: response.data.error, life: 3000 });
        setLoadingBasicUpdate(false);
        return;
      }

      if (languageCode !== i18n.language) {
        i18n.changeLanguage(languageCode);
      }

      // Update display values only after successful update
      setUserDisplayEmail(userEmail);
      setUserDisplayName(userName);
      setUserDisplaySurname(userSurname);

      getProfileBasicDetail();

      setTimeout(() => {
        toast.current.show({ severity: 'success', summary: t("successful"), detail: t("updateSuccessful"), life: 3000 });
        setLoadingBasicUpdate(false);
      }, 0);
    }).catch((error) => {
      console.log('updateProfileBasicDetail', error);
      setLoadingBasicUpdate(false);
    });
  };




  const updateProfileDefaults = () => {
    try {
      if (defaultSecuritySetItem === undefined) {
        toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Menkul Değer Seçiniz', life: 3000 });
        return;
      }

      // Check if there are changes
      if (!hasSecurityChanges()) {
        toast.current.show({
          severity: 'warn',
          summary: t("warning"),
          detail: t("noChangesWarning"),
          life: 3000
        });
        return;
      }

      setLoadingDefaultsUpdate(true);
      const entityId = defaultSecuritySetItem.objectId;
      const securityCode = defaultSecuritySetItem.code;

      profileService.profileSetstockGet(token, entityId, securityCode).then((response) => {
        if (response.data.error.length > 0) {
          toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data.error, life: 3000 });
          setLoadingDefaultsUpdate(false);
          return;
        }
        toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Varsayılan Menkul Değiştirildi', life: 3000 });
        dispatch(setMainDefaultSecurity(securityCode));
        setLoadingDefaultsUpdate(false);
      }).catch((error) => {
        console.log('setDefaultSecurity', error);
        setLoadingDefaultsUpdate(false);
      });
    } catch (error) {
      console.log('setDefaultSecurity', error);
      setLoadingDefaultsUpdate(false);
    }
  }

  return (
    <div id="profile" className="m-t-40" style={{ height: '84.4vh' }}>
      <Toast ref={toast} position='bottom-right' />
      <Container>
        <Row className="m-0">
          <Col lg="3" id="profileSettingsInfo">
            <Row id="profilInfoDiv">
              <div className="icon-wrapper">
                <FontAwesomeIcon icon={faUser} />
              </div>
              <label className="userName m-t-15">{`${userDisplayName || ""} ${userDisplaySurname || ""}`.trim()}</label>
              <label className="userEmail">{userDisplayEmail || userMail}</label>

              <div className='profil-menu-div'>
                {profileTypes.map((item, childIndex) => (
                  <div className={[`profil-menu-item ${item.isActive ? "active" : ""}`]} key={item.id} onClick={() => handleListItemClick(item, item)}>
                    <label className='title'>
                      {t(item.name)}
                    </label>
                    <FontAwesomeIcon className='arrow-icon' icon={faChevronRight} />
                  </div>
                ))}
              </div>

              <Button variant="dark" className="logoutBtn" onClick={handleLogout}>
                {t('logout')}
              </Button>
            </Row>
          </Col>

          <Col lg="9" id="profileInfo">
            <Row className="borderDiv p-15">
              {activeListItemId === 'basicDetails' && (
                <div id="basicDetails">
                  <Row>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="ControlInput1">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.nameSurname')} </Form.Label>
                        <Row>
                          <Col style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <Form.Control
                              type="text"
                              placeholder={t('profile.basicDetails.name')}
                              value={userName}
                              onChange={(e) => setUserName(e.target.value)}
                            />
                          </Col>
                          <Col style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <Form.Control
                              type="text"
                              placeholder={t('profile.basicDetails.surname')}
                              value={userSurname}
                              onChange={(e) => setUserSurname(e.target.value)}
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>

                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="ControlInput2">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.mobilePhone')}</Form.Label>
                        <MaskedInput
                          value={userMobilPhone}
                          type="text"
                          className="form-control"
                          name="phoneNumber"
                          placeholder="(###)-###-##-##"
                          guide={false}
                          mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                          onChange={(e) => {
                            const formattedValue = e.target.value.replace(/[()\s-]/g, '');
                            setUserMobilPhone(formattedValue);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="ControlInput3">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.dataOfBirth')}</Form.Label>
                        <DatePicker date={userBirthDate} selectedDate={selectedBirtdate} maxDate={new Date()} />
                      </Form.Group>
                    </Col>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="ControlInput4">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.officePhone')}</Form.Label>
                        <MaskedInput
                          value={userOfficePhone}
                          type="text"
                          className="form-control"
                          placeholder="(###)-###-##-##"
                          guide={false}
                          name="phoneNumber"
                          mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                          onChange={(e) => {
                            const formattedValue = e.target.value.replace(/[()\s-]/g, '');
                            setUserOfficePhone(formattedValue);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="ControlInput5">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.emailAdress')}</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Email Adres"
                          value={userEmail}
                          onChange={(e) => setUserEmail(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="6">
                      <Form.Group className="mb-3" id="country-dropdown2">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.selectCountry')}</Form.Label>
                        <InputGroup className="user-password-input-group w-100">
                          <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                            <Dropdown data-bs-theme="dark">
                              {userCountry.flag ? (
                                <Image
                                  src={userCountry.flag}
                                  className="userLoginKeyIcon"
                                  style={{ width: '36px', height: '37px' }}
                                />
                              ) : (
                                <FontAwesomeIcon icon={faGlobe} className="userLoginKeyIcon" />
                              )}
                              <Dropdown.Toggle
                                variant="secondary"
                                className="w-100"
                                style={{
                                  color: userCountry ? '' : 'gray'
                                }}>
                                {userCountry.name || t('profile.basicDetails.selectCountry')}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu">
                                {countryItems.map((item) => (
                                  <Dropdown.Item
                                    key={`country-${item.id}-${item.name}`}  // Modified key to ensure uniqueness
                                    onClick={() => changeCountryValue(item)}
                                    className={item.id === userCountry.id ? "comboActiveItem" : ""}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        {item.flag ? (
                                          <Image
                                            src={item.flag}
                                            style={{ width: '18px', height: '18px', marginRight: '8px', display: 'flex' }}
                                          />
                                        ) : (
                                          <FontAwesomeIcon icon={faGlobe} className="" style={{ marginRight: '8px', fontSize: '17px' }} />
                                        )}
                                        <span>{item.name}</span>
                                      </div>
                                      {item.id === userCountry.id && <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />}
                                    </div>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <Form.Group className="mb-3" id="product-dropdown">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.productsOfInterest')}</Form.Label>
                        <InputGroup className="user-password-input-group w-100">
                          <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                            <Dropdown data-bs-theme="dark">
                              <Dropdown.Toggle
                                variant="secondary"
                                className="w-100"
                                style={{
                                  color: selectedProducts.length > 0 ? '' : 'gray'
                                }}>
                                {selectedProducts.length > 0
                                  ? selectedProducts.map(p => p.name).join(', ')
                                  : t('profile.basicDetails.selectProducts')}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu">
                                {interestedProducts.map((item) => (
                                  <Dropdown.Item
                                    key={item.id}
                                    onClick={() => toggleProductSelection(item)}
                                    className={selectedProducts.some(p => p.id === item.id) ? "comboActiveItem" : ""}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        <span>{item.name}</span>
                                      </div>
                                      {selectedProducts.some(p => p.id === item.id) &&
                                        <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />}
                                    </div>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col lg="6">
                      <Form.Group className="mb-3" id="investment-dropdown">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.investmentAmountYouConsider')}</Form.Label>
                        <InputGroup className="user-password-input-group w-100">
                          <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                            <Dropdown data-bs-theme="dark">
                              <Dropdown.Toggle
                                variant="secondary"
                                className="w-100"
                                style={{
                                  color: selectedInvestment ? '' : 'gray'
                                }}>
                                {selectedInvestment ? selectedInvestment.name : " "}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu">
                                {investmentAmount.map((item) => (
                                  <Dropdown.Item
                                    key={item.id}
                                    onClick={() => changeInvestmentValue(item)}
                                    className={selectedInvestment && item.id === selectedInvestment.id ? "comboActiveItem" : ""}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        <span>{item.name}</span>
                                      </div>
                                      {selectedInvestment && item.id === selectedInvestment.id && <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />}
                                    </div>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <Form.Group className="mb-3" id="city-dropdown">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.selectCity')}</Form.Label>
                        <InputGroup className="user-password-input-group w-100">
                          <InputGroup.Text id="inputGroup-sizing-default" className="p-5 w-100">
                            <Dropdown data-bs-theme="dark">
                              <Dropdown.Toggle
                                variant="secondary"
                                className="w-100"
                                style={{
                                  color: selectedCity ? '' : 'gray'
                                }}>
                                {selectedCity ? selectedCity.name : t('profile.basicDetails.selectCity')}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu">
                                {cityItems.map((item) => (
                                  <Dropdown.Item
                                    key={item.id}
                                    onClick={() => handleCityChange(item)}
                                    className={selectedCity && item.id === selectedCity.id ? "comboActiveItem" : ""}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        <span>{item.name}</span>
                                      </div>
                                      {selectedCity && item.id === selectedCity.id && <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />}
                                    </div>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                      <Form className="mt-4">
                        <Form.Check
                          inline
                          value="man"
                          label={t('profile.basicDetails.man')}
                          name="group2"
                          type="radio"
                          id={`gender-inline-radio-1`}
                          checked={gender === 'man'}
                          onChange={() => changeGender('man')}  // Add onChange handler
                        />
                        <Form.Check
                          inline
                          value="women"
                          label={t('profile.basicDetails.woman')}
                          name="group2"
                          type="radio"
                          id={`gender-inline-radio-2`}
                          checked={gender === 'women'}
                          onChange={() => changeGender('women')}  // Add onChange handler
                        />
                        <Form.Check
                          inline
                          value="nothing"
                          label={t('profile.basicDetails.wantToSpecify')}
                          name="group2"
                          type="radio"
                          id={`gender-inline-radio-3`}
                          checked={gender === 'nothing'}
                          onChange={() => changeGender('nothing')}  // Add onChange handler
                        />
                      </Form>
                    </Col>
                    <Col lg="6">
                      <Form.Group className="mb-3">
                        <Form.Label className="customInputLabel">{t('profile.basicDetails.yourAddress')}</Form.Label>
                        <InputTextarea
                          value={address}
                          onChange={handleAddressChange}
                          placeholder={t('profile.basicDetails.yourAddress')}
                          rows={15}
                          className="w-100 adress-textarea"

                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Divider align="center"></Divider>
                  <Row style={{ display: 'inline' }}>
                    {/* Basic Details Update Button */}
                    <Button slot="end" variant="dark" className="saveButton" onClick={updateProfileBasicDetail} disabled={loadingBasicUpdate}>
                      {loadingBasicUpdate ? (
                        <><FontAwesomeIcon icon={faSpinner} spin />{' '}{t('update')}</>
                      ) : (
                        t('update')
                      )}
                    </Button>
                  </Row>
                </div>
              )}

              {activeListItemId === 'defaultSettings' && (
                <div id="defaultSettings">
                  <Col lg="12">
                    <div className="defaults-search-section">
                      <div className="defaults-search-header">
                        <span className="defaults-search-label">{t('profile.defaults.securities')}</span>
                      </div>
                      <div className="defaults-search-input">
                        <Search inputValue={defaultSecurity} selectedSearchItem={selectedSearchItem} />
                      </div>
                    </div>
                    <Divider align="center"></Divider>
                    <Row style={{ display: 'inline' }}>
                      <Button slot="end" variant="dark" className="saveButton" onClick={updateProfileDefaults} disabled={loadingDefaultsUpdate}>
                        {loadingDefaultsUpdate ? (
                          <><FontAwesomeIcon icon={faSpinner} spin />{' '}{t('update')}</>
                        ) : (
                          t('update')
                        )}
                      </Button>
                    </Row>
                  </Col>
                </div>
              )}
              {activeListItemId === 'changePassrword' && (
                <ChangePasswordTab mainApi={mainApi} userProfileId={userProfileId} toast={toast} t={t} />
              )}
              {activeListItemId === 'changeLanguage' && (
                <div>
                  <Row>
                    <Form.Label className="customInputLabel m-b-10">{t('profile.language.languageSelection')}</Form.Label>
                    <Form>
                      <Form.Check
                        value="tr-TR"
                        label={t('language.turkish')}
                        name="group2"
                        type="radio"
                        id='radio-1'
                        checked={languageCode === "tr-TR"}
                        onChange={() => changeLanguage('tr-TR')}  // Add onChange handler
                      />
                      <Form.Check
                        value="en-US"
                        label={t('language.english')}
                        name="group2"
                        type="radio"
                        id='radio-2'
                        checked={languageCode === "en-US"}
                        onChange={() => changeLanguage('en-US')}  // Add onChange handler
                      />
                    </Form>
                  </Row>
                  <Divider align="center"></Divider>
                  <Row style={{ display: 'inline' }}>
                    {/* Language Update Button (uses the same loading state as Basic Details) */}
                    <Button slot="end" variant="dark" className="saveButton" onClick={updateProfileBasicDetail} disabled={loadingBasicUpdate}>
                      {loadingBasicUpdate ? (
                        <><FontAwesomeIcon icon={faSpinner} spin />{' '}{t('update')}</>
                      ) : (
                        t('update')
                      )}
                    </Button>
                  </Row>
                </div>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Profile;



